import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_acbb4naqbw: FaireBrandEntity = {
  token: "b_acbb4naqbw",
  type: "brand",
  name: "Crowned Free",
  avatarUrl:
    "https://cdn.faire.com/fastly/4b08b8492d93e3e5f2333508d0d793bdd5dab7a1e95de403cb33e16f9eafe1c0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2cc838e0a64628b0ec3ac93103662392ee6bdda92e46134c8181a05ef0f484b1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4b08b8492d93e3e5f2333508d0d793bdd5dab7a1e95de403cb33e16f9eafe1c0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2cc838e0a64628b0ec3ac93103662392ee6bdda92e46134c8181a05ef0f484b1.jpeg",
  location: "Caledonia, MI, USA",
  minimumOrderDollars: 104,
  rating: 5,
  reviewCount: 108,
  isTopShop: true,
  isInsider: true,
  description:
    "Crowned Free is on a mission to end human trafficking through ethical fashion and gifts featuring boho-inspired women's clothing, survivor-made candles and jewelry, home decor, and accessories. We give back by creating safe and sustainable jobs for survivors who make many of our products. We also financially support anti-trafficking organizations here in the USA and around the world! ",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:28.553Z",
    importedBy: "entity-db-cli",
  },
};
